var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"c-footer g-flux--large t-t2 t-black"},[_c('router-link',{attrs:{"to":"/mentions-legales","tag":"a"}},[_vm._v("Mentions légales")]),_c('p',[_vm._v("🍪 free !")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }